// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { InternalConfig } from "./config.js";
